import { apiRequest } from "@/lib/queryClient";
import type {
  ApiResponse,
  MintCNFTRequest,
  MintCNFT,
} from "@/types/cnft";

export const cnftApi = {
  /**
   * Mint an NFT (requires authentication)
   * Database triggers will automatically update partner stats
   */
  mintCNFT: async (request: MintCNFTRequest): Promise<ApiResponse<MintCNFT>> => {
    return apiRequest<ApiResponse<MintCNFT>>(
      "POST",
      `/api/v1/cnft/mint`,
      {
        partnerId: request.partnerId,
      }
    );
  },
};
